<div class="data-section" *ngIf="!orderable && successor$ | async as successor">
  <ng-container class="data-image" *ngIf="successorImage$ | async as image">
    <cx-media [container]="image" [alt]="successor.name"></cx-media>
  </ng-container>
  <div class="data-name">
    <a
      [routerLink]="'/v/' + successor.code | cxUrl"
      [attr.data-cy]="'successor-link-' + successor.code"
    >
      {{ successor.name }}
    </a>
  </div>
  <div class="data-icon">
    <a [routerLink]="'/v/' + successor.code | cxUrl">
      <span class="fas fa-info-circle"></span>
    </a>
  </div>
</div>
